import moment from 'moment';

export const isWebview = () => {
    const useragent = navigator.userAgent;
    const rules = ["WebView", "(iPhone|iPod|iPad)(?!.*Safari/)", "Android.*(wv|.0.0.0)"];
    const regex = new RegExp(`(${rules.join("|")})`, "ig");
    return Boolean(useragent.match(regex));
  };
  

export const extractTimeFromDateBulk = operations => {
  Object.keys(operations).forEach(item => {
    if (typeof operations[item].from == 'object') {
      if (((operations[item].from).toString()).includes('GMT')) {
        operations[item].from = extractTimeFromDate(operations[item].from);
      }
    }

    if (typeof operations[item].to == 'object') {
      if (((operations[item].to).toString()).includes('GMT')) {
        operations[item].to = extractTimeFromDate(operations[item].to);
      }
    }
  });
  return operations;
}

export const extractTimeFromDate = date => {
  return moment(date).format("HH:mm");
}

export const shuffleArray = (array) => {
  var currentIndex = array.length, temporaryValue, randomIndex;

  // While there remain elements to shuffle...
  while (0 !== currentIndex) {

    // Pick a remaining element...
    randomIndex = Math.floor(Math.random() * currentIndex);
    currentIndex -= 1;

    // And swap it with the current element.
    temporaryValue = array[currentIndex];
    array[currentIndex] = array[randomIndex];
    array[randomIndex] = temporaryValue;
  }

  return array;
}


// WEBPACK FOOTER //
// ./util/generalFunction.js